import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormField,
  handleChangeFormField,
} from '@tock/shared/ui/forms/formHelpers';
import TextField, { TextFieldProps } from 'omakase/FormControls/TextField';
import _ from 'lodash';

const FormTextField: React.FunctionComponent<TextFieldProps> = ({
  helperText,
  onChange,
  onBlur,
  ...rest
}) => {
  const idValue = rest.id ?? rest.name;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [fieldConfig, meta] = useField(rest as FieldHookConfig<any>);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(fieldConfig, event, onChange);
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormField(fieldConfig, event, onBlur);
  const hasError = checkFormHasError(meta);
  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  // Destructuring out onChange and onBlur to prevent them from being declared twice on TextField
  const trimmedFieldConfig = _.omit(fieldConfig, ['onChange', 'onBlur']);

  return (
    <TextField
      id={idValue}
      error={hasError}
      helperText={helperTextValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...trimmedFieldConfig}
      {...rest}
    />
  );
};

export default FormTextField;
